export const getItem = (key: string) => localStorage.getItem(key);
export const setItem = (key: string, value: any) => localStorage.setItem(key, value);
export const removeItem = (key: string) => localStorage.removeItem(key);
export const getItemObject = (key: string) => {
  const item = getItem(key);
  return item && JSON.parse(item);
};
export const setItemObject = (key: string, value) => {
  setItem(key, JSON.stringify(value));
};
